export default "__VITE_ASSET__085d4eb1__"